"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _useVisibilityHook2 = _interopRequireDefault(require("../useVisibilityHook"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Resource = function Resource(props) {
  var content = props.content,
    language = props.language;
  var _useVisibilityHook = (0, _useVisibilityHook2["default"])(props),
    isClickable = _useVisibilityHook.isClickable,
    isVisible = _useVisibilityHook.isVisible;
  if (!isVisible) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  if (!content.resourceId) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  var shareUrl = (0, _get2["default"])(content, 'resource.share_url');
  if (!shareUrl) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  var displayText = '';
  if (language === 'en' && 'headingEn' in content) {
    displayText = content.headingEn;
  } else if (language === 'es' && 'headingEs' in content) {
    displayText = content.headingEs;
  }
  var iconUrl = (0, _get2["default"])(content, 'thumbnail.thumbnailSmall');
  if (!iconUrl) {
    iconUrl = (content === null || content === void 0 ? void 0 : content.thumbnail) === 'default' ? (0, _get2["default"])(content, 'resource.small') : '';
  }
  if (!displayText && !iconUrl) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: shareUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "".concat(_style["default"].link, " ").concat(isClickable ? '' : _style["default"].disabled),
    onClick: function onClick(event) {
      if (!isClickable) {
        event.preventDefault();
      }
    }
  }, iconUrl && /*#__PURE__*/_react["default"].createElement("img", {
    alt: displayText || 'Icon',
    src: iconUrl,
    className: _style["default"].icon
  }), displayText && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: displayText
  })));
};
var _default = exports["default"] = Resource;